import { useScreenSize } from '@utilities/hooks/useScreenSize';
import { FC, ReactNode, useMemo } from 'react';
import { Icon } from '../icon';
import { ColorsEnum } from '@utilities/enums';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children: ReactNode;
    customClassName?: string;
}

export const Modal: FC<ModalProps> = ({
    isOpen,
    onClose,
    title,
    children,
    customClassName,
}) => {
    const { isMobile, isTablet } = useScreenSize();

    const modalWidth = useMemo(() => {
        if (isMobile) return 'w-[100%]';
        if (isTablet) return 'max-w-[95%] min-w-[400px]';
        return 'max-w-[70%] min-w-[600px]';
    }, [isMobile, isTablet]);

    const modalHeight = useMemo(() => (isMobile ? 'h-[100vh]' : 'min-h-[10vh]'), [isMobile]);

    const modalRadius = useMemo(() => (isMobile ? 'rounded-none' : 'rounded-lg'), [isMobile]);

    const modalChildrenMaxHeight = useMemo(() => (isMobile ? 'max-h-[90vh]' : 'max-h-[60vh]'), [isMobile]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div
                className={`bg-white ${modalRadius} shadow-lg  ${modalWidth}  ${modalHeight} ${customClassName} relative transition-transform transform scale-100`}
            >
                {/* En-tête fixe */}
                <div className="flex items-center rounded-lg justify-between p-4 sticky top-0 bg-white z-10 border-b">
                    {title && <h2 className="text-xl font-semibold">{title}</h2>}
                    <Icon
                        onPress={onClose}
                        iconName='CircleX'
                        size={25}
                        color={ColorsEnum.PRIMARY}
                    />
                </div>

                {/* Contenu défilant */}
                <div className={`p-6 overflow-y-auto ${modalChildrenMaxHeight}`}>
                    {children}
                </div>
            </div>
        </div>
    );
};
